import React, { useState, useEffect, useRef } from "react";
import "../styles/Review.css";

import student1 from "../assets/student1.jpeg";
import student2 from "../assets/student2.jpeg";
import student3 from "../assets/student3.jpeg";
import student4 from "../assets/student4.jpg";
import student5 from "../assets/student5.jpeg";
import student6 from "../assets/student6.jpg";
import student7 from "../assets/student7.jpeg";

const images = [
  student1,
  student2,
  student3,
  student4,
  student5,
  student6,
  student7,
];

const Review = () => {
  const [currentIndex, setCurrentIndex] = useState(
    Math.floor(images.length / 2)
  );
  const [isMobile, setIsMobile] = useState(false);

  // for mobile slider
  const sliderRef = useRef(null);
  const [activeDot, setActiveDot] = useState(0);

  useEffect(() => {
    // elfSight script (unchanged)
    const script = document.createElement("script");
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  // detect mobile
  useEffect(() => {
    const mq = () => setIsMobile(window.innerWidth <= 768);
    mq();
    window.addEventListener("resize", mq);
    return () => window.removeEventListener("resize", mq);
  }, []);

  // desktop controls (unchanged)
  const prevSlide = () =>
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  const nextSlide = () => setCurrentIndex((prev) => (prev + 1) % images.length);

  const getStyle = (index) => {
    const position = index - currentIndex;
    let offset = position;
    if (position > images.length / 2) offset -= images.length;
    if (position < -images.length / 2) offset += images.length;
    if (Math.abs(offset) > 2) return { display: "none" };
    const scale = offset === 0 ? 1 : 0.8;
    const translateX = offset * 95;
    const zIndex = 100 - Math.abs(offset);
    return {
      transform: `translateX(${translateX}%) scale(${scale})`,
      zIndex,
      filter: "none",
      opacity: 1,
      display: "block",
    };
  };

  // ===== Mobile slider helpers =====
  const scrollToSlide = (i) => {
    const el = sliderRef.current;
    if (!el) return;
    const width = el.clientWidth; // each slide is 100% width
    el.scrollTo({ left: i * width, behavior: "smooth" });
  };

  useEffect(() => {
    if (!isMobile || !sliderRef.current) return;

    const el = sliderRef.current;
    let ticking = false;

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const width = el.clientWidth || 1;
          const i = Math.round(el.scrollLeft / width);
          setActiveDot(Math.max(0, Math.min(images.length - 1, i)));
          ticking = false;
        });
        ticking = true;
      }
    };

    el.addEventListener("scroll", onScroll, { passive: true });
    return () => el.removeEventListener("scroll", onScroll);
  }, [isMobile]);

  return (
    <section id="reviews" className="review-section">
      <div className="proud-graduate-title">
        Our Proud <br className="mobile-break" /> Graduates
      </div>

      {/* Desktop original carousel */}
      {!isMobile && (
        <div className="carousel-wrapper">
          <button className="nav-arrow arrow-left" onClick={prevSlide}>
            &#8249;
          </button>
          <div className="carousel">
            {images.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`Slide ${index + 1}`}
                className="carousel-image"
                style={getStyle(index)}
              />
            ))}
          </div>
          <button className="nav-arrow arrow-right" onClick={nextSlide}>
            &#8250;
          </button>
        </div>
      )}

      {/* Mobile swipe slider with dots */}
      {isMobile && (
        <div className="mobile-slider">
          <div className="slides" ref={sliderRef}>
            {images.map((img, i) => (
              <div className="slide" key={i}>
                <img src={img} alt={`Slide ${i + 1}`} className="slide-image" />
              </div>
            ))}
          </div>
          <div className="dots">
            {images.map((_, i) => (
              <button
                key={i}
                className={`dot ${i === activeDot ? "active" : ""}`}
                aria-label={`Go to slide ${i + 1}`}
                onClick={() => scrollToSlide(i)}
              />
            ))}
          </div>
        </div>
      )}

      <section className="google-reviews">
        <div
          className="elfsight-app-18147341-4cba-4220-a730-072d492b4864"
          data-elfsight-app-lazy
        />
      </section>
    </section>
  );
};

export default Review;
